/*
 * MWS product options on product pages (snippets/mws_apo_helper.liquid, assets/mws-options.css).
 * The chip distribution of snippets/mws_apo_helper.liquid ("You have 0/300 poker chips") becomes a translated counter
 * ("Chip count" / "Plaque count") with a bar that turns green when every chip is distributed, as in the "Edit
 * options" window in the cart. Empty number fields get "0" as a hint. The app builds and rebuilds the options, so
 * this runs again after every change; it only writes when something changed.
 * Every field at 0 means the standard distribution. A distribution that is started but does not add up (100 of 300)
 * is not added to the cart: the distribution opens with a message (2026-11-03; it went through to the checkout).
 */
(function () {
  /* The distribution as entered: chips counted and the number of the set, or null without a distribution */
  function distribution() {
    var container = document.querySelector('.product-options-container');
    if (!container) return null;

    var info = container.querySelector('.infoChips');
    var limit = container.querySelector('.mwHide.limit .mw-option__value-text');
    var total = limit ? parseInt(limit.textContent, 10) : NaN;
    if (!info || !isFinite(total) || total <= 0) return null;

    var sum = 0;
    container.querySelectorAll('.mw-option--type-number .mw-option__control[type="number"]').forEach(function (input) {
      if (!input.placeholder) {
        input.placeholder = '0';
        input.inputMode = 'numeric';
      }
      var value = parseInt(input.value, 10);
      if (isFinite(value) && value > 0) sum += value;
    });

    return { container: container, info: info, total: total, sum: sum };
  }

  function isPlaques() {
    var product = window.mwsShopInfo && window.mwsShopInfo.product;
    return !!product && /plaque/i.test((product.type || '') + ' ' + (product.title || ''));
  }

  function update() {
    var labels = document.querySelector('[data-mws-option-labels]');
    var state = distribution();
    if (!labels || !state) return;

    var info = state.info, total = state.total, sum = state.sum;

    var box = info.querySelector('.mws-chips');
    if (!box) {
      box = document.createElement('div');
      box.className = 'mws-chips notranslate';
      box.setAttribute('translate', 'no'); // already translated, Transcy should leave it alone
      box.innerHTML = '<span class="mws-chips__text"></span><span class="mws-chips__bar"><span></span></span>';
      info.appendChild(box);
    }

    // Plaque sets count plaques, the rest chips
    var text = labels.getAttribute(isPlaques() ? 'data-plaque-count' : 'data-chip-count').replace('%c', sum).replace('%t', total);
    var textElement = box.querySelector('.mws-chips__text');
    if (textElement.textContent !== text) textElement.textContent = text;

    var width = Math.min(100, Math.round((sum * 100) / total)) + '%';
    var bar = box.querySelector('.mws-chips__bar span');
    if (bar.style.width !== width) bar.style.width = width;

    info.classList.toggle('is-complete', sum === total);

    // The message goes once the distribution adds up or is back to the standard one
    var error = box.querySelector('.mws-chips__error');
    if (error && !error.hidden && (sum === 0 || sum === total)) error.hidden = true;
    else if (error && !error.hidden) showError(state, labels, error);
  }

  function showError(state, labels, error) {
    var text = (labels.getAttribute(isPlaques() ? 'data-incomplete-plaques' : 'data-incomplete') || '').replace('%c', state.sum).replace('%t', state.total);
    if (error.textContent !== text) error.textContent = text;
    error.hidden = false;
  }

  /* Add to cart (the app's own button or the form) with a started, incomplete distribution: stopped before the app
     handles it (window, capture phase), the distribution opened with the message */
  function guard(event) {
    var target = event.target;
    var button = event.type === 'submit' ? target : target.closest && target.closest('.mw-apo-add-to-cart-cloned, .product-form [type="submit"]');
    if (!button || (event.type === 'submit' && !(target.matches && target.matches('form.product-form')))) return;

    var labels = document.querySelector('[data-mws-option-labels]');
    var state = distribution();
    if (!labels || !state || state.sum === 0 || state.sum === state.total) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    update();
    var box = state.info.querySelector('.mws-chips');
    if (!box) return;
    var error = box.querySelector('.mws-chips__error');
    if (!error) {
      error = document.createElement('p');
      error.className = 'mws-chips__error';
      error.setAttribute('role', 'alert');
      box.appendChild(error);
    }
    showError(state, labels, error);

    var options = state.container.closest('[data-pset-options]') || state.container;
    if (options.classList.contains('pset-options') && !options.classList.contains('is-distribution-open')) {
      options.classList.add('is-distribution-open');
      var toggle = options.querySelector('[data-pset-distribution]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }
    state.info.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  window.addEventListener('click', guard, true);
  window.addEventListener('submit', guard, true);

  document.addEventListener('input', function (event) {
    if (event.target.closest && event.target.closest('.product-options-container')) update();
  });

  document.addEventListener('DOMContentLoaded', update);

  new MutationObserver(update).observe(document.documentElement, { childList: true, subtree: true });
})();
